var map = {
	"./2018-03-04/whats-new.html": 2101,
	"./2018-04-12/whats-new.html": 2102,
	"./2018-04-24/whats-new.html": 2103,
	"./2018-05-23/whats-new.html": 2104,
	"./2018-05-31/whats-new.html": 2105,
	"./2018-07-04/whats-new.html": 2106,
	"./2018-07-19/whats-new.html": 2107,
	"./2018-11-20/whats-new.html": 2108,
	"./2019-04-04/whats-new.html": 2109,
	"./2020-01-21/whats-new.html": 2110,
	"./2020-07-18/whats-new.html": 2111,
	"./2021-06-10/whats-new.html": 2112,
	"./2021-07-26/whats-new.html": 2113,
	"./2021-08-26/whats-new.html": 2114,
	"./2021-12-07/whats-new.html": 2115,
	"./2022-06-03/whats-new.html": 2116,
	"./2022-09-08/whats-new.html": 2117,
	"./2023-01-01/whats-new.html": 2118,
	"./2023-06-14/whats-new.html": 2119
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2100;


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update ^\.\/.*\/whats\-new\.html$
// module id = 2100
// module chunks = 0